'use client';

import { c as _c } from "react/compiler-runtime";
import { BuilderBlocks } from '@builder.io/react';
import type { ReactNode } from 'react';
import { memo } from 'react';
import { type RailProps } from '@src/components/Rail/Rail.props';
import { RailItemContextProvider } from '@src/components/Rail/RailItemContext';
import { cn } from '@src/utils/tailwind';
type Props = {
  blocks?: ReactNode[] | ReactNode;
  builderBlock?: any;
  imageStyle?: RailProps['imageStyle'];
  index: number;
  isPreviewing?: boolean;
  columnsDesktop: number;
  slug?: string;
};
const RailItemBase = props => {
  const $ = _c(18);
  const {
    blocks,
    builderBlock,
    imageStyle,
    index,
    isPreviewing,
    columnsDesktop,
    slug
  } = props;
  let t0;
  let t1;
  if ($[0] !== columnsDesktop || $[1] !== imageStyle || $[2] !== index || $[3] !== isPreviewing) {
    const imageClasses = cn("[&_.rail-img]:relative [&_.rail-img]:overflow-hidden", "[&_.rail-img_img]:absolute [&_.rail-img_img]:inset-0 [&_.rail-img_img]:object-cover", "[&_.rail-img_img]:size-full", "[&_.rail-img]:rounded-[14px] lg:[&_.rail-img]:rounded-[30px]", {
      "[&_.rail-img]:aspect-square": imageStyle === "square",
      "[&_.rail-img]:aspect-250/171": imageStyle === "horizontal",
      "[&_.rail-img]:aspect-250/309": imageStyle === "vertical",
      "lg:[&_.rail-img]:rounded-[14px]": columnsDesktop >= 5
    });
    const previewClasses = cn({
      "before:content-[\"Item_\"attr(data-index)] before:absolute before:w-full before:top-0 before:px-2 before:rounded-sm  before:font-bold before:-translate-y-full before:-translate-x-1/2 before:left-1/2 before:bg-blue-50 before:text-blue-950": isPreviewing
    });
    t0 = index + 1;
    t1 = cn("relative h-full", imageClasses, previewClasses);
    $[0] = columnsDesktop;
    $[1] = imageStyle;
    $[2] = index;
    $[3] = isPreviewing;
    $[4] = t0;
    $[5] = t1;
  } else {
    t0 = $[4];
    t1 = $[5];
  }
  const t2 = index + 1;
  const t3 = builderBlock?.id;
  const t4 = `component.options.items.${index}.blocks`;
  let t5;
  if ($[6] !== blocks || $[7] !== t3 || $[8] !== t4) {
    t5 = <BuilderBlocks className="h-full justify-between" parentElementId={t3} blocks={blocks} dataPath={t4} />;
    $[6] = blocks;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== slug || $[11] !== t2 || $[12] !== t5) {
    t6 = <RailItemContextProvider slug={slug} position={t2}>{t5}</RailItemContextProvider>;
    $[10] = slug;
    $[11] = t2;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t0 || $[15] !== t1 || $[16] !== t6) {
    t7 = <div data-index={t0} className={t1}>{t6}</div>;
    $[14] = t0;
    $[15] = t1;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  return t7;
};
export const RailItem = memo(RailItemBase);